import { Injectable } from '@angular/core';
import { CasesState } from '../core/states/cases.state';
import { EntitiesState } from '../core/states/entities.state';
import { NomenclatorState } from '../core/states/nomenclator.state';
import { AttentionsState } from '../core/states/attentions.state';
import { TasksState } from '../core/states/tasks.state';
import { CategoriesofEvolutionsState } from '../core/states/categories-of-evolutions.state';
import { ArrangementsState } from '../core/states/arrangements.state';
import { ProvisionsState } from '../core/states/provisions.state';
import { MapsSate } from '../core/states/maps.state';
import { ModulesState } from '../core/states/modules.state';
import { CasesFacade } from './cases.facade';
import { EntitiesFacade } from './entities.facade';
import { NomenclatorFacade } from './nomenclator.facade';

@Injectable({
    providedIn: 'root',
})
export class RootFacade {

    constructor(
        // ! Define all states here
        private casesState: CasesState,
        private entitiesState: EntitiesState,
        private nomenclatorState: NomenclatorState,
        private attentionState: AttentionsState,
        private tasksState: TasksState,
        private categoriesofEvolutionsState: CategoriesofEvolutionsState,
        private arrangementsState: ArrangementsState,
        private provisionsState: ProvisionsState,
        private mapsState: MapsSate,
        private modulesState: ModulesState,
        // Facades with tenant-scoped caches that must be cleared on logout
        private casesFacade: CasesFacade,
        private entitiesFacade: EntitiesFacade,
        private nomenclatorFacade: NomenclatorFacade,
    ) { }

    cleanStore() {
        const properties = Object.getOwnPropertyNames(this);
        properties.forEach(p => {
            this[p].cleanStore();
        })
    }

    cleanActiveCaseStore(opts: { modules?: boolean; orders?: boolean } = { modules: true, orders: true }) {
        if (opts.modules) {
            this.modulesState.resetCaseScopedState();
        }

        if (opts.orders) {
            this.casesState.resetCaseScopedOrders();
        }
    }
}
